import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy's Users page is People.
export const Route = createFileRoute('/admin/users')({
  staticData: { minTier: 'FRONT_END_SUPPORT' },
  beforeLoad: () => {
    throw redirect({ to: '/admin/people/' });
  },
});
